import { createContext, useContext, useState, useCallback, useEffect } from 'react';

const AccessibilityContext = createContext();

export function AccessibilityProvider({ children }) {
  const [textSize, setTextSize] = useState('normal'); // 'small', 'normal', 'large'

  const changeTextSize = useCallback((size) => {
    setTextSize(size);
  }, []);

  useEffect(() => {
    // Remove all text size classes first
    document.body.classList.remove('text-size-small', 'text-size-normal', 'text-size-large');
    // Add the current text size class
    document.body.classList.add(`text-size-${textSize}`);
  }, [textSize]);

  return (
    <AccessibilityContext.Provider value={{ textSize, changeTextSize }}>
      {children}
    </AccessibilityContext.Provider>
  );
}

export function useAccessibility() {
  const context = useContext(AccessibilityContext);
  if (!context) {
    throw new Error('useAccessibility must be used within an AccessibilityProvider');
  }
  return context;
}
